import { render } from "./subject_tree.vue?vue&type=template&id=40c8d5e0&scoped=true"
import script from "./subject_tree.js?vue&type=script&lang=js"
export * from "./subject_tree.js?vue&type=script&lang=js"

import "./subject_tree.vue?vue&type=style&index=0&id=40c8d5e0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c8d5e0"]])

export default __exports__